import { render, staticRenderFns } from "./TableInfo.vue?vue&type=template&id=a7621a9a&scoped=true&"
import script from "./TableInfo.vue?vue&type=script&lang=js&"
export * from "./TableInfo.vue?vue&type=script&lang=js&"
import style0 from "./TableInfo.vue?vue&type=style&index=0&id=a7621a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7621a9a",
  null
  
)

export default component.exports